module.exports = __webpack_public_path__ + "static/media/planEmerg_1.070f02ae.png";